/**
 * Hvilken sessionId widgeten skal lagre etter et svar fra serveren.
 *
 * Serveren er ENESTE autoritet på hvilken sesjon som gjelder. Den slår opp
 * ID-en klienten sendte, og finnes den ikke (samtalen er slettet fra
 * dashbordet, basen er ryddet, ID-en er fra et annet miljø) oppretter den en
 * fersk sesjon og returnerer DEN ID-en i stedet.
 *
 * Widgeten adopterte tidligere serverens ID kun når den selv ikke hadde noen
 * (`if (!sessionId.value) ...`). En død ID i localStorage ble derfor aldri
 * erstattet: hver melding sendte den døde ID-en på nytt, serveren laget en ny
 * sesjon hver gang, og samtalen mistet hukommelsen mellom hver eneste melding.
 * Alle kallene svarte HTTP 200, så feilen var usynlig — den viste seg bare som
 * at Iskra hilste på nytt i hver tur.
 *
 * Regelen er derfor: stol alltid på serveren.
 */
export function shouldAdoptSessionId(
  current: string | null,
  fromServer: string | null | undefined
): fromServer is string {
  if (!fromServer) return false;
  return fromServer !== current;
}
